// rng.js - Deterministic, seedable pseudo-random number generator.
//
// Why: the game's score is computed client-side, so for a trustworthy weekly
// leaderboard a backend needs to be able to re-create (and re-validate) a run.
// The first requirement is that the level layout is reproducible from a single
// number. All GAMEPLAY randomness (platform/enemy/coin/boost spawns) goes
// through one seeded generator; purely cosmetic randomness (background stars,
// particle bursts) intentionally stays on Math.random so it never perturbs the
// reproducible gameplay sequence.

// mulberry32: tiny, fast, good-enough-quality PRNG. Returns a function that
// yields floats in [0, 1) — a drop-in replacement for Math.random.
export const createRng = (seed) => {
  let a = seed >>> 0;
  return () => {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
};

// A fresh 32-bit seed for a new run (uses Math.random — this is the only place
// real entropy enters; the seed itself is recorded in the run receipt).
export const randomSeed = () => Math.floor(Math.random() * 0xffffffff) >>> 0;
